// Don't format this file

import React, { useEffect, useState } from "react";
import enGb from "date-fns/locale/en-GB";
import { registerLocale } from "react-datepicker";
import Select from "react-select";
import { getAllProjectList, saveProjectCheckList } from "../API";
import { toast } from "react-toastify";
import AddTempProjectModal from "./AddTempProjectModal";
import { getTodayDate } from "../utils/utils";
registerLocale("en-gb", enGb);

const AddNewCheckList = (props) => {
  const { refreshData, setIsLoading } = props;
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState({
    label: "",
    value: "",
  });

  const virtual_id = getTodayDate();

  const fetchAllProjects = async () => {
    const projects = await getAllProjectList();
    setProjectList(
      projects?.data?.map((project) => ({
        label: project?.description,
        value: project?.id,
      }))
    );
  };

  useEffect(() => {
    fetchAllProjects();
  }, []);

  const onClickSubmit = async () => {
    const payload = {
      project_id: selectedProject.value,
      pole_number: "",
      kv: 0,
      access: "",
      status: 0,
    };
    setIsLoading(true);
    try {
      await saveProjectCheckList(payload).then((res) => {
        if (res?.status === 200) {
          toast.success("Checklist Added Successfully");
          refreshData();
        } else {
          toast.error("Failed to add checklist");
        }
      });
    } catch (error) {
      toast.error("Failed to add checklist");
    } finally {
      setIsLoading(false);
    }
  };

  const handleProjectChange = (item, e) => {
    setSelectedProject(item);
  };

  return (
    <>
      <div
        className="modal fade add-new-timesheet-modal"
        id="addNewChecklist"
        tabIndex="-1"
        aria-labelledby="addNewTimeSheetLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="addNewTimeSheetLabel"
              >
                Add New Checklist
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={() => {
                //   setStartDate("");
                //   setSelectedOption({ label: "", value: "" });
                //   setOptions([]);
                // }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="checklist-modal-field">
                <label htmlFor="" className="checklist-modal-label">
                  Select Project *
                </label>
                <Select
                  placeholder="Select Project"
                  value={{
                    label: selectedProject.label,
                    value: selectedProject.value,
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  name="project"
                  options={projectList}
                  onChange={(item, e) => handleProjectChange(item, e)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn primary-btn-outlined add-proj-btn"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#addNewTempProject"
              >
                Add new project
              </button>
              <button
                disabled={!selectedProject.value}
                data-bs-dismiss="modal"
                type="button"
                className="primary-btn"
                style={{
                  background: !selectedProject.value ? "grey" : undefined,
                  cursor: !selectedProject.value ? "not-allowed" : "pointer",
                }}
                aria-label="Close"
                onClick={() => onClickSubmit()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <AddTempProjectModal
        virtualId={virtual_id}
        getTimeSheetWeekDetails={refreshData}
        timeSheetDetails={"timeSheetDetails"}
        type="checklist"
      />
    </>
  );
};

export default AddNewCheckList;
